module.exports = __webpack_public_path__ + "static/window-sticker-655cf850ade2e587ef1bd2a7df2c8b5e.png";